import React from 'react';
import { Button } from './ui/Button';
export function AboutSection() {
  return <section className="bg-black py-16 sm:py-24 px-4 sm:px-6 lg:px-8" data-id="element-6">
      <div className="mx-auto max-w-7xl" data-id="element-7">
        <div className="grid grid-cols-1 gap-10 sm:gap-16 lg:grid-cols-2 lg:gap-24 items-center" data-id="element-8">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1" data-id="element-9">
            <div className="aspect-[3/4] w-full overflow-hidden bg-neutral-900" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/wyJdqihftFWySVQLvFSeEE/borci.webp" alt="DREAMBIG Photography" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" data-id="element-11" />
            </div>
            {/* Decorative Element - hidden on mobile */}
            <div className="hidden sm:block absolute -bottom-6 -right-6 -z-10 h-full w-full border border-neutral-800" data-id="element-12" />
          </div>

          {/* Text Side */}
          <div className="order-1 lg:order-2" data-id="element-13">
            <h2 className="mb-6 sm:mb-8 text-3xl sm:text-4xl font-light leading-tight text-white lg:text-5xl xl:text-6xl" data-id="element-14">
              O <span className="font-serif italic text-neutral-400" data-id="element-15">meni</span>
            </h2>

            <div className="space-y-4 sm:space-y-6 text-base sm:text-lg font-light leading-relaxed text-neutral-300" data-id="element-16">
              <p data-id="element-17">
                Moja naloga je, da vas spremljam pri vsem, kar počnete, in
                ujamem tiste dragocene trenutke — tiste desetinke, stotinke in
                tisočinke, ki so za vas najbolj pomembni.
              </p>
              <p data-id="element-18">
                Naše sodelovanje se začne s prijetnim prvim srečanjem in se
                konča z nepozabno izkušnjo, ne glede na to, ali ste pred
                objektivom prvič ali stotič.
              </p>
            </div>

            <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4" data-id="element-19">
              <Button variant="primary" className="w-full sm:w-auto" onClick={() => document.getElementById('dosezki')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-20">
                Ogled portfolia
              </Button>
              <Button variant="outline" className="w-full sm:w-auto" onClick={() => document.getElementById('kontakt')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-21">
                Kontakt
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}